import React from 'react';
import { Linkedin, Instagram, Youtube } from 'lucide-react';
import { NAV_LINKS } from '../mock';

export default function Footer() {
  return (
    <footer className="ob-dark-section bg-[var(--ob-dark)] px-5 pb-10 pt-16 text-white md:px-8">
      <div className="mx-auto max-w-[1280px]">
        <div className="grid grid-cols-1 gap-10 border-b border-white/10 pb-12 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <div className="flex items-center">
              <img
                src="/onbrand-logo-white.png"
                alt="OnBrand Emails"
                className="h-9 w-auto"
                data-testid="footer-logo"
              />
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/55">
              An email &amp; SMS retention partner for ambitious Shopify brands. Official
              Klaviyo partners engineering profitable revenue.
            </p>
            <div className="mt-6 flex gap-3">
              {[
                { Icon: Linkedin, label: "Jake's LinkedIn", href: 'https://www.linkedin.com/in/jake-kelly-bb81a3323/' },
                { Icon: Instagram, label: 'OnBrand on Instagram', href: 'https://www.instagram.com/onbrand.emails/?hl=en' },
                { Icon: Youtube, label: 'OnBrand on YouTube', href: 'https://youtube.com/@jakeonbrand?si=41VRNkly-7FhxMIa' },
              ].map(({ Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors hover:border-[var(--ob-accent)] hover:text-[var(--ob-accent)]"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wide text-white/80">Explore</h4>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-white/55 transition-colors hover:text-[var(--ob-accent)]">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-bold uppercase tracking-wide text-white/80">Get Started</h4>
            <p className="mt-5 text-sm text-white/55">
              Book a free strategy audit and see exactly where your retention is leaking revenue.
            </p>
            <a
              href="https://calendly.com/hello-onbrandadmin/30min" target="_blank" rel="noopener noreferrer"
              className="ob-btn mt-5 inline-flex items-center rounded-full bg-[var(--ob-accent)] px-8 py-4 text-base font-bold text-[var(--ob-dark)] hover:bg-white"
            >
              Book A Free Audit
            </a>
          </div>
        </div>

        <div className="flex flex-col items-center justify-center gap-3 pt-8 text-sm text-white/40 md:flex-row">
          <span>© {new Date().getFullYear()} OnBrand Emails. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
